export default __webpack_public_path__ + "static/media/baby4road 1.1e467182.png";